import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FileUrlPipe } from './file-url.pipe';

@NgModule({
   declarations: [FileUrlPipe],
   exports: [FileUrlPipe],
   imports: [CommonModule],
})
export class FileUrlPipeModule {}
